function isOvpResponseError(response) {
    return (typeof response === 'object' &&
        response !== null &&
        'body' in response &&
        typeof response.body === 'object' &&
        'status' in response &&
        typeof response.status === 'number');
}
function getErrorDescriptionFromResponse(response) {
    if (isOvpResponseError(response)) {
        return response.body.description;
    }
    return null;
}
function getOvpErrorCodeFromResponse(response) {
    if (isOvpResponseError(response)) {
        return response.body.errorCode;
    }
    return null;
}
function responseHasStatusCode(response, status) {
    if (isOvpResponseError(response)) {
        return response.status === status;
    }
    return null;
}
export function getErrorClassFromResponse(response, errorCodes) {
    var errorMapResult = errorCodes.find(function (_a) {
        var httpStatus = _a.httpStatus, ovpErrorCode = _a.ovpErrorCode;
        return responseHasStatusCode(response, httpStatus) && getOvpErrorCodeFromResponse(response) === ovpErrorCode;
    });
    if (errorMapResult) {
        return errorMapResult.errorClass;
    }
    else {
        return null;
    }
}
export function getOvpErrorFromResponse(response, errorCodes) {
    var OvpErrorClass = getErrorClassFromResponse(response, errorCodes);
    if (OvpErrorClass) {
        var errorDescription = getErrorDescriptionFromResponse(response);
        return new OvpErrorClass(errorDescription, {
            cause: response,
            code: getOvpErrorCodeFromResponse(response),
        });
    }
    else {
        return null;
    }
}
export function throwOvpErrors(errorCodeMap) {
    return function (response) {
        var ovpError = getOvpErrorFromResponse(response, errorCodeMap);
        if (ovpError) {
            throw ovpError;
        }
        return response;
    };
}
//# sourceMappingURL=error-utils.js.map